// Example 'CUSTOM_ERROR=1010?quoteno=80980987&info2=324=2'
// TODO: Decompose and refactor.
const HEADER = 'CUSTOM_ERROR'
export type CustomErrorCodeName = 'processing_quote';
const ERROR_CODES: { [key in CustomErrorCodeName]: string } = {
  processing_quote: '1010'
}

export const isErrorCodeExist = (code: string) => Object.values(ERROR_CODES).includes(code)
const errorInfoKeys: { [key: string]: string[] } = {
  ['1010']: ['quoteno']
}

export const createCustomError = (code: string, info: { [key: string]: string }): string | null => {
  if (!isErrorCodeExist(code)) return null
  let error = HEADER + '=' + code
  errorInfoKeys[code].forEach((key: string, index) => {
    const value = info[key]
    if (index === 0) error += `?${key}=${value}`
    else error += `&${key}=${value}`
  })
  return error
}
